import theme from '../../../../../../../lib/theme';

const {
  corners,
  scale,
  shadows,
  colors,
  media,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({
  link: {
    textDecoration: 'none',

    '&:hover .CustomFeature__title': {
      textDecoration: 'underline',
      color: colors.sas.primary,
    },

    '&:hover .CustomFeature__image': {
      boxShadow: shadows.lowest,
    },
  },
  tag: {
    display: 'inline-block',
    borderBottomRightRadius: corners.m,
    textTransform: 'uppercase',
    padding: `${scale.xxxxs} ${scale.xs}`,
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: colors.red,
    color: colors.white,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.xl,
  },

  category: {
    color: colors.sas.primary,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.l,
    textDecoration: 'none',
  },

  featuretext: {
    [media.l.up]: {
      flex: `calc(33.33% - ${scale.m}) 0`,
      width: `calc(33.33% - ${scale.m})`,
      '& > *': {
        width: '100%',
      },
    },
  },

  highlight: {
    backgroundColor: colors.tas.secondary,
    color: colors.black,
    fontSize: font.l,
    fontFamily: families.primary,
    lineHeight: heights.l,
    marginLeft: `-${scale.xxs}`,
    [media.l.up]: {
      width: 'auto',
    },
  },
  featureImage: {
    width: '100%',
    borderRadius: corners.m,
    display: 'block',
    [media.l.up]: {
      flex: `calc(68.66% - ${scale.m}) 0`,
    },
  },
  imageBackground: {
    display: 'flex',
    flex: 1,
    height: '100%',
    top: 0,
    left: 0,
    position: 'absolute',
    '> button': {
      display: 'none',
    },
    width: '100%',
    ':hover': {
      transition: 'opacity 0.5s ease',
      backgroundImage:
        'linear-gradient(rgba(101,31,255,0.4), rgba(101,31,255,0.4))',
      display: 'flex',
    },
    ':hover > button': {
      border: `2px solid ${colors.white}`,
      backgroundColor: 'transparent',
      color: colors.white,
      fontFamily: families.primary,
      fontSize: font.l,
      fontWeight: font.normal,
      lineHeight: heights.xxl,
      display: 'inline-block',
      position: 'absolute',
      left: 'calc(50% - 85px)',
      width: '170px',
      top: 'calc(50% - 22.5px)',
      height: '45px',
      borderRadius: '28.5px',
      cursor: 'pointer',
    },
  },
  featureImageContainer: {
    marginBottom: scale.s,
    position: 'relative',
    width: '100%',
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
    [media.l.up]: {
      width: `calc(68.66% - ${scale.m})`,
      marginBottom: scale.m,
    },
  },

  subtitle: {
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    color: colors.black,
  },

  featureContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [media.l.up]: {
      flexDirection: 'row',
    },
  },

  featuretitle: {
    color: colors.black,
    marginBottom: 0,
    transition: 'all 150ms linear',
    fontFamily: families.primary,
    fontSize: font.xl,
    fontWeight: font.bold,
    lineHeight: heights.xl,

    [media.l.up]: {
      fontSize: font.xxl,
      lineHeight: heights.xxl,
    },
  },
});
